import styled from 'styled-components';

const Wrapper = styled.div`
	display: flex;
	.invert-color {
		filter :invert(1)
	}
	.coin-ico {
		width: 40px;
		height: 40px;
		border-radius: 25px;
		font-size: 11px !important;
		text-align: center;
		background-color: #212121;
		box-sizing: content-box;
		border: 1.5px solid #A8A8B1;
		border-color: #A8A8B1;
		color: #fff;
		font-weight: bold;
		display:flex;
		align-items:center;
		justify-content:center;
		flex-direction:column;

		span {
			padding-left:0px !important;
		}
	}
	.coin-ico.btc {
		border-color: #f7941d;
	}
	.coin-ico.xrp {
		border-color: #414042;
	}
	.coin-ico.bch {
		border-color: #8dc541;
	}
	.coin-ico.eth {
		border-color: #3e4ea1;
	}
	.coin-ico.hex {
		border-color: #000000;
	}
	.coin-ico.xht {
		border-color: #A8A8B1;
	}
	.coin-ico.xmr {
		border-color: #f15a29;
	}
	.coin-ico.dai {
		border-color: #f3c27a;
	}
	.coin-ico.mkr {
		border-color: #00a79d;
	}
	.coin-ico.btc, .coin-ico.xrp, .coin-ico.bch, .coin-ico.eth, .coin-ico.hex, .coin-ico.xht, .coin-ico.xmr, .coin-ico.dai, .coin-ico.mkr, .coin-ico.usdt {
		background-color: #212121;
		color: #FFFFFF;
	}
	.coin-ico.link {
		color: #000000 !important;
		cursor: text !important;
		text-decoration: none !important;
	}
	.coin-name {
		padding-left: 8px;
		font-size: 24px;
		font-weight: bold;
	}
	&.xs {
		.coin-ico {
			width: 30px;
			height: 30px;
			border-radius: 16px;
			font-size: 5px !important;
			font-weight: normal;
		}

		.coin-ico.btc {
			border-color: #f7941d;
		}
		.coin-name {
			padding-left: 8px;
			font-size: 14px;
			font-weight: normal;
		}
	}
	&.md {
		.coin-ico {
			width: 60px;
			height: 60px;
			border-radius: 32px;
			font-size: 12px !important;
			font-weight: normal;
		}

		.coin-name {
			padding-left: 8px;
			font-size: 14px;
			font-weight: normal;
		}
	}
	&.large-no-hover {
		.coin-ico {
			width: 94px;
			height: 94px;
			border-radius: 47px;
			font-size: 18px !important;
			position: relative;
			overflow: hidden;
			cursor: pointer;

			p {
				font-size: 12px;
				line-height: 1;
				position: relative;
				font-weight: normal;
			}
		}
	}
	&.large {
		.coin-ico {
			width: 94px;
			height: 94px;
			border-radius: 47px;
			font-size: 18px !important;
			position: relative;
			overflow: hidden;
			cursor: pointer;
			&:hover::before {
				content: '+';
				position: absolute;

				z-index: 1;
				display: block;
				width: 95px;
				height: 95px;
				border-radius: 47.5px;
				font-size: 30px;
				background-color: #00f;
				color: #fff;
				text-align: center;
			}
			p {
				font-size: 12px;
				line-height: 1;
				position: relative;
				font-weight: normal;
			}
		}
		.coin-ico.btc {
			&:hover::before {
				background-color: #f7941d;
			}
		}
		.coin-ico.xrp {
			&:hover::before {
				background-color: #414042;
			}
		}
		.coin-ico.bch {
			&:hover::before {
				background-color: #8dc541;
			}
		}
		.coin-ico.eth {
			&:hover::before {
				background-color: #3e4ea1;
			}
		}
		.coin-ico.hex {
			&:hover::before {
				background-color: #000000;
			}
		}
		.coin-ico.xht {
			&:hover::before {
				background-color: #000000;
			}
		}
		.coin-ico.xmr {
			&:hover::before {
				background-color: #f15a29;
			}
		}
		.coin-ico.dai {
			&:hover::before {
				background-color: #f3c27a;
			}
		}
		.coin-ico.mkr {
			&:hover::before {
				background-color: #00a79d;
			}
		}
		.coin-ico.xht {
			&:hover::before {
				background-color: #000000;
			}
		}
	}
	@media (max-width: 1200px) {
		.coin-ico {
			width: 28px;
			height: 28px;
			border-radius: 17px;
			font-size: 10px !important;
			text-align: center;
			border-color: #0000ff;

			font-weight: bold;
		}
		.coin-name {
			padding-left: 8px;
			font-size: 16px;
		}
	}
	@media (max-width:300px) {
        &.large-no-hover {
            .coin-ico {
                width: 80px;
                height: 80px;
            }
        }
    }
`;

export default Wrapper;
